import { render, staticRenderFns } from "./ShimmerTableRows.vue?vue&type=template&id=5e9ef56a&scoped=true&"
import script from "./ShimmerTableRows.vue?vue&type=script&lang=js&"
export * from "./ShimmerTableRows.vue?vue&type=script&lang=js&"
import style0 from "./ShimmerTableRows.vue?vue&type=style&index=0&id=5e9ef56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9ef56a",
  null
  
)

export default component.exports